import React, {Component} from 'react';
import {
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Button from '../../../shared/components/Button';
import Avatar from '../../../shared/components/Avatar';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import { 
  alphabeticallySort,
  textContains
} from '../../../shared/utils';

class AccountUserList extends Component {
  render(){
    const { users, match, updateUser, history } = this.props;

    return (
      <div>
        <Row>
          <Col xs='12'>
            <SearchableDataTable 
              items={users}
              emptyText='This account has no users linked to it'
              isActiveFunc={(item) => item.active}
              columns={[
                {
                  width:10,
                  renderCell:(item) => (
                    <Avatar 
                      userName={item.firstName}
                      imageUrl={item.avatarThumbnailURL}
                    />
                  )
                },{
                  display:'name',
                  name:'firstName',
                  width:50,
                  filterFunc:(a,searchParam) => textContains(`${a.firstName} ${a.lastName}`,searchParam),
                  sortFunc:(a,b) => alphabeticallySort(a.firstName,b.firstName),
                  renderCell:(item) => (
                    <Link to={`${match.url}/${item.id}/edit`}>
                      {item.firstName} {item.lastName}
                    </Link>
                  )
                },{
                  display:'role',
                  name:'isOwner',
                  width:10,
                  sortFunc:(a,b) => b.isOwner - a.isOwner,
                  renderCell:(item) => (<span>{item.isOwner ? 'Admin' : 'Creator'}</span>)
                },{
                  width:30,
                  alwaysActive:true,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`${match.url}/${item.id}/edit`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button> 
                      &nbsp;&nbsp;
                      <DropdownButton 
                        options={[
                          {
                            text:'Impersonate',
                            onClick:() => history.push(`/impersonate/${item.email}/experiences`)
                          },
                          {
                            text:item.active ? 'Deactivate' : 'Activate', 
                            onClick:() => updateUser(item.id,{active:!item.active})
                          }
                        ]} 
                      />
                    </div>                      
                  )
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

export default AccountUserList;



// WEBPACK FOOTER //
// ./src/routes/AccountUserList/components/AccountUserList.js